module.exports = __webpack_public_path__ + "static/media/birthday.f1c4a959.png";